import api from "../../../api"

export function getPerformance(payload) {
  return api.post(`call-performance-report`, payload);
}
